module.exports = {
  Others: 'Khác',
  YouToViewOrFiles: 'Bạn không có quyền xem hoặc tải xuống tệp do người khác tải lên hoặc in.',
  BookingAgent: 'Đại lý đặt chỗ',
  BasicInformation: 'Thông tin cơ bản',
  FileHistory: 'Lịch sử tệp',
  Cancel: 'Hủy',
  Save: 'Lưu',
  SynchronizeFees: 'Đồng bộ chi phí',
  ProjectNameCannotBeEmpty: 'Tên dự án không được để trống!',
  CustomerNameCannotBeEmpty: 'Tên khách hàng không được để trống!',
  ProjectCycleCannotBeEmpty: 'Chu kỳ dự án không được để trống!',
  EndBeEarlierThanDate: 'Ngày kết thúc không được sớm hơn ngày bắt đầu!',
  AccountingCurrencyCannotBeEmpty: 'Loại tiền tệ không được để trống!',
  ProjectManagerCannotBeEmpty: 'Quản lý dự án không được để trống!',
  ProjectDepartmentCannotBeEmpty: 'Phòng ban dự án không được để trống!',
  ProjectCompanyCannotBeEmpty: 'Công ty dự án không được để trống!',
  SaveSuccessfully: 'Lưu thành công',
  TheStatusCannotBeEdited: 'Trạng thái dự án hiện tại không thể chỉnh sửa!',
  TheStatusCannotBeDeleted: 'Trạng thái dự án hiện tại không thể xóa',
  PleaseToDeleteTheNumber: 'Vui lòng xác nhận có xóa mã số',
  Prompt: 'Thông báo',
  Confirm: 'Xác nhận',
  DeleteSuccessfully: 'Xóa thành công',
  CancelledDeletion: 'Đã hủy xóa',
  ProjectStatusCompleted: 'Trạng thái dự án đã hoàn thành',
  PleaseCanCloseTheNumber: 'Vui lòng xác nhận có thể đóng mã số',
  ClosedSuccessfully: 'Đóng thành công',
  ClosedCancelled: 'Đã hủy đóng',
  ProjectStatusInProgress: 'Trạng thái dự án đang tiến hành',
  PleaseNeedToReopenNumber: 'Vui lòng xác nhận cần mở lại mã số',
  SuccessfullyOpened: 'Mở thành công',
  CancelledOpening: 'Đã hủy mở',
  PleaseSelectARecord: 'Vui lòng chọn một bản ghi!',
  DeletedSuccessfully: 'Xóa thành công',
  DeletionCancelled: 'Đã hủy xóa',
  CancelledClosing: 'Đã hủy đóng',
  OpenedSuccessfully: 'Mở thành công',
  XNotAllowViewOrDownload: 'Tệp {0} không cho phép bất kỳ ai xem hoặc tải xuống.',
  NoPermissionView: 'Bạn không có quyền xem hoặc tải xuống tệp {0}',
  PleaseToDeleteTheProject: 'Vui lòng xác nhận có xóa dự án mã số {0}'
}
